import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import useUsersMeta from '@hooks/useUsersMeta';
import { RegistrationFormItem, type RegistrationFormItemProps } from '../RegistrationFormItem';

export const TitleFormItem = ({
  selectProps,
  ...props
}: RegistrationFormItemProps & { selectProps?: Partial<ComponentProps<typeof Select>> }) => {
  const { t } = useTranslation('common');
  const titles = useUsersMeta()?.titles;

  const defaultSelectProps = {
    role: 'combobox' as const,
    'aria-expanded': false,
    'aria-required': true,
    'aria-label': 'Select your title',
    ...selectProps
  };

  return (
    <RegistrationFormItem label={t('Title')} name="title" rules={[{ required: true }]} {...props}>
      <Select
        options={titles?.map(({ title }) => ({ label: title, value: title }))}
        data-testid="title-select"
        {...defaultSelectProps}
      />
    </RegistrationFormItem>
  );
};
